import { createContext, useContext, useState, type ReactNode } from 'react'

interface ViewedPascosContextType {
    viewedPascos: Set<string>
    markPascoAsViewed: (pascoId: string) => void
    isPascoViewed: (pascoId: string) => boolean
    clearViewedPascos: () => void
}

const ViewedPascosContext = createContext<ViewedPascosContextType | undefined>(undefined)

interface ViewedPascosProviderProps {
    children: ReactNode
}

export function ViewedPascosProvider({ children }: ViewedPascosProviderProps) {
    const [viewedPascos, setViewedPascos] = useState<Set<string>>(new Set())

    const markPascoAsViewed = (pascoId: string) => {
        setViewedPascos(prev => new Set(prev).add(pascoId))
    }

    const isPascoViewed = (pascoId: string) => {
        return viewedPascos.has(pascoId)
    }

    const clearViewedPascos = () => {
        setViewedPascos(new Set())
    }

    return (
        <ViewedPascosContext.Provider
            value={{
                viewedPascos,
                markPascoAsViewed,
                isPascoViewed,
                clearViewedPascos
            }}
        >
            {children}
        </ViewedPascosContext.Provider>
    )
}

export function useViewedPascos() {
    const context = useContext(ViewedPascosContext)
    if (context === undefined) {
        throw new Error('useViewedPascos must be used within a ViewedPascosProvider')
    }
    return context
}